import { useTranslation } from 'react-i18next';
import { Stack, Tag, Text } from 'shell/components';
import { getLatestPushbackRecord, getSubmissionLmsSyncStatus } from 'utils/gradePushback';

const LmsSyncStatus = ({ submission, assignment }) => {
    const { t } = useTranslation();
    const status = getSubmissionLmsSyncStatus(submission, assignment);
    const latest = getLatestPushbackRecord(submission);

    if (!status) return <Text>--</Text>;

    const label = status === 'synced' ? t('tag.synced', 'Synced') : t('tag.needs-attention', 'Needs attention');
    const pushedAt = latest?.pushed_at ? new Date(latest.pushed_at) : null;
    const tagValue = status === 'synced' ? 'synced' : 'needsAttention';

    const formattedDate = pushedAt
        ? t('ui.format-date-time-short', '{{val, date_time_short}}', { val: pushedAt })
        : '--';

    return (
        <Tag
            tooltip={{
                component: (
                    <Stack spacing={1}>
                        <Text color={'inherit'} weight={'semibold'}>
                            {label}
                        </Text>
                        <Text color={'inherit'}>
                            {t('ui.last-pushed', 'Last pushed')} {formattedDate}
                        </Text>
                    </Stack>
                ),
                maxWidth: 240,
                placement: 'bottom-start',
            }}
            type={'general'}
            value={tagValue}
        />
    );
};

export default LmsSyncStatus;
